module.exports = __webpack_public_path__ + "static/img/meizu15Plus.ac78619a.jpg";